import {
    CHANGE_FILTERED_CHATS_CHAT_LIST_EDITOR,
    CHANGE_SEARCH_INPUT_CHAT_LIST_EDITOR,
    ChangeFilteredChatsChatListEditorAction,
    ChatListEditorAction,
    CLOSE_CHAT_LIST_EDITOR,
    FETCH_CHATS_CHAT_LIST_EDITOR,
    OPEN_CHAT_LIST_EDITOR,
    OpenChatListEditorAction,
    SELECT_CHAT_LIST_EDITOR,
    SelectChatListEditorAction,
    SHOW_CHATS_ERROR_CHAT_LIST_EDITOR,
    UPDATE_CHATS_CHAT_LIST_EDITOR
} from '../../actions/chatList';
import {
    chatListInitialData,
    findChatOperatorById
} from '../../service/ChatListEditor/ChatListEditor';
import { ChatListEditorState, ChatListItem } from '../../typings/chatList';
import { State } from '../../typings/state';

export const chatListInitialState = {
    editors: {}
};

const openChatListEditorReducer = (
    state: ChatListEditorState,
    action: OpenChatListEditorAction
): ChatListEditorState => {
    const { editorId, savedValue } = action;
    const editorState = state.editors[editorId] || chatListInitialData;

    return {
        ...state,
        editors: {
            [editorId]: {
                ...editorState,
                ...savedValue,
                isOpen: true
            }
        }
    };
};

const selectChatListEditorReducer = (
    state: ChatListEditorState,
    action: SelectChatListEditorAction
): ChatListEditorState => {
    const editorId = action.editorId;
    const editorState = state.editors[editorId] || chatListInitialData;
    const selectedChat = findChatOperatorById(state.chats, action.selectedId);

    return {
        ...state,
        editors: {
            [editorId]: {
                ...editorState,
                selectedChatId: selectedChat && selectedChat.id
            }
        }
    };
};

const changeFilteredChatsChatListEditorReducer = (
    state: ChatListEditorState,
    action: ChangeFilteredChatsChatListEditorAction
): ChatListEditorState => {
    const editorId = action.editorId;
    const editorState = state.editors[editorId] || chatListInitialData;
    const chats = state.chats;
    const value = action.filterValue;

    if (value === '' || !chats || !chats.length) {
        return {
            ...state,
            editors: {
                [editorId]: {
                    ...editorState,
                    filteredChats: undefined
                }
            }
        };
    }

    const filteredChats = chats.filter((elem: ChatListItem) => {
        return (
            elem.name.toLowerCase().includes(value.toLowerCase()) ||
            `id ${elem.skillId.toLowerCase()}`.includes(value.toLowerCase())
        );
    });

    return {
        ...state,
        editors: {
            [editorId]: {
                ...editorState,
                filteredChats
            }
        }
    };
};

export function chatListEditorReducer(
    state: ChatListEditorState = chatListInitialState,
    action: ChatListEditorAction,
    fullState: State
): ChatListEditorState {
    switch (action.type) {
        case OPEN_CHAT_LIST_EDITOR:
            return openChatListEditorReducer(state, action);

        case CLOSE_CHAT_LIST_EDITOR:
            return {
                ...state,
                editors: {
                    [action.editorId]: {
                        ...state.editors[action.editorId],
                        ...chatListInitialData
                    }
                }
            };

        case UPDATE_CHATS_CHAT_LIST_EDITOR:
            return {
                ...state,
                chats: action.chats
            };

        case CHANGE_SEARCH_INPUT_CHAT_LIST_EDITOR:
            return {
                ...state,
                editors: {
                    [action.editorId]: {
                        ...state.editors[action.editorId],
                        searchInputText: action.searchInputText
                    }
                }
            };

        case SELECT_CHAT_LIST_EDITOR:
            return selectChatListEditorReducer(state, action);

        case FETCH_CHATS_CHAT_LIST_EDITOR:
            return {
                ...state,
                apiError: false,
                chats: undefined
            };

        case SHOW_CHATS_ERROR_CHAT_LIST_EDITOR:
            return {
                ...state,
                apiError: true
            };

        case CHANGE_FILTERED_CHATS_CHAT_LIST_EDITOR:
            return changeFilteredChatsChatListEditorReducer(state, action);

        default:
            return state;
    }
}
